/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueTextButtonComponent } from '.';
import { DxButtonModule } from 'devextreme-angular';

@NgModule({
  declarations: [SysqueTextButtonComponent],
  imports: [CommonModule, DxButtonModule],
  exports: [SysqueTextButtonComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueTextButtonModule {}
